<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">轮播图管理</div>
          <span class="m-title-s">对轮播图新增、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>轮播图列表
<!--            <span style="font-size: 14px;margin-left: 20px;color: #ff4d51;">(取最新三张图片)</span>-->
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup" type="primary" size="">新增轮播图</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="image" label="图片" width="">
            <template slot-scope="scope">
              <div style="height: 120px;">
                <img v-if="scope.row.image" :src="$httpConf.ossURL + scope.row.image" style="object-fit: contain;width: 100%; height: 100%;">
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题" width=""></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="80">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === '1'" type="success">正常</el-tag>
              <el-tag v-else type="danger">关闭</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="110" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="110" align="center"></el-table-column>
          <el-table-column prop="remarks" label="备注" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row)" plain>编辑</el-button>
              <el-button type="danger" size="mini" @click="thisDel(scope.row.id)" plain>删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="750px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="标题: " prop="title">
              <el-input v-model="form.title" placeholder="输入标题"></el-input>
            </el-form-item>
            <el-form-item label="轮播图片: " prop="imgPath">
              <div style="display: flex;">
                <div style="width: 30%;">
                  <el-upload
                    drag
                    :action="uploadAction"
                    :headers="myHeaders"
                    accept=".jpg, .png"
                    :limit="1"
                    :file-list="fileLists"
                    :on-success="imgSuccess"
                    :on-remove="imgRemove">
                    <div style="font-size: 12px; line-height: 26px;display: flex; flex-wrap: wrap;align-items: center; height: 130px;">
                      <div>
                        <div style="width: 100%;"><i style="font-size: 28px" class="el-icon-upload2"></i></div>
                        <div style="width: 100%;text-align: center;">拖拽或<em style="color: #1c9dff">点击上传</em></div>
                      </div>
                    </div>
                  </el-upload>
                </div>
                <div style="width: 70%">
                  <div style="width: 253px; height: 128px;margin-left: 20px;border-radius: 8px;overflow: hidden;">
                    <img :src="$httpConf.ossURL + form.image" alt="" width="100%" height="100%">
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="图片路径: " prop="image">
              <el-input v-model="form.image" :disabled="true" placeholder="输入图片路径"></el-input>
            </el-form-item>
            <el-form-item label="排序: " prop="sort">
              <el-input v-model="form.sort" placeholder="输入排序"></el-input>
            </el-form-item>
            <el-form-item label="设置状态: " prop="isStatus">
              <el-switch v-model="isStatus" active-text="开启" inactive-text="关闭"></el-switch>
            </el-form-item>
            <el-form-item label="备注: " prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'CarouselManage',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      list: [],
      uploadAction: '',
      myHeaders: { Authorization: JSON.parse(window.sessionStorage.user).Authorization },
      fileLists: [],
      form: {
        id: '',
        title: '',
        image: '',
        sort: '',
        status: '',
        remarks: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
        image: [
          {required: true, message: '请输入图片路径', trigger: 'blur'}
        ],
        sort: [
          {required: true, message: '请输入排序', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    // 赋值图片上传路径
    this.uploadAction = this.$httpConf.baseURL + '/carousel/uploadImage'
  },
  methods: {
    // 删除图片
    imgRemove () {
      this.form.image = ''
      this.fileLists = []
    },
    // 图片上传成功
    imgSuccess (response, file, fileList) {
      if (file.response.status === 200) {
        this.form.image = file.response.data
        this.fileLists = [{url: this.$httpConf.ossURL + file.response.data}]
        this.$message.success('上传成功')
      }
    },
    closeDialog: function () {
      this.form = {
        id: '',
        title: '',
        image: '',
        sort: '',
        status: '',
        remarks: ''
      }
      this.openText = '新增'
      this.openState = false
      this.formLoading = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          _this.form.status = _this.isStatus ? '1' : '0'
          this.$axios.post('/carousel/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.listData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.formLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    thisDel (id) {
      let _this = this
      this.$messageBox.confirm('此操作将永久删除当前项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/carousel/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    openForm (row) {
      this.openText = '编辑'
      this.form = {
        id: row.id,
        title: row.title,
        image: row.image,
        sort: row.sort,
        status: row.status,
        remarks: row.remarks
      }
      this.isStatus = row.status === '1'
      this.openState = true
    },
    // 管理员列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/carousel/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData()
  }
}
</script>
<style>
  .avatar-uploader {border: 1px dashed #d9d9d9;width: 310px;height: 152px;border-radius: 6px;overflow: hidden;}
  .avatar-uploader:hover {border-color: #409EFF;}
  .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 310px;height: 152px;line-height: 152px;text-align: center;}
  .avatar {width: 310px; height: 152px; display: block;}

  .el-upload-dragger {
    width: 170px;
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/platform/Carousel.vue